// Imports
import { useStateValue } from '../../_global/jsx/store';

export const ReactBarChart = (props) => {

    const [{ globalText }, dispatch] = useStateValue();
    const {userScore, industryScore} = props;

    let barProgressClass;
    let barProgressSRlabel;
    let industryBarStyles = {};
    let userBarStyles = {};
    let sectionNotComplete = (userScore === 'N/A' || isNaN(userScore)) ? 'br-app-bar__incomplete' : '';
    let userScoreResult = (userScore === 'N/A' || isNaN(userScore)) ? 0 : userScore;
    
    let rangeWeakness = parseInt(globalText.barChartRange_weakness);
    if(isNaN(rangeWeakness) === true){rangeWeakness = 50;}
    let rangeStrength = parseInt(globalText.barChartRange_strength);
    if(isNaN(rangeStrength) === true){rangeWeakness = 75;}

    
    if (userScoreResult > rangeStrength) {
        barProgressClass = ' bq-app-bar__chart--strength';
        barProgressSRlabel = globalText.colourKeyLabelStrength;
    } else if (userScoreResult > rangeWeakness) {
        barProgressClass = ' bq-app-bar__chart--improvement';
        barProgressSRlabel = globalText.colourKeyLabelImprovement;
    } else if(userScoreResult <= 0) {
        barProgressClass = ' bq-app-bar__chart--none';
        barProgressSRlabel = globalText.colourKeyLabelWeakness;
    } else {
        barProgressClass =' bq-app-bar__chart--weakness';
        barProgressSRlabel = globalText.colourKeyLabelWeakness;
    }

    industryBarStyles['width'] = `${industryScore ? industryScore : 0}%`;
    userBarStyles['width'] = `${userScore === 'N/A' ? 0 : userScore}%`;


    return (
        <div className={`br-app-bar__wrapper ${sectionNotComplete}`}>
            <div className="br-app-bar br-app-bar__industry">
                <span className="br-app-bar__label">{globalText.barChartIndustryLabel}</span>
                <div className="br-app-bar__chart">
                    <div className="br-app-bar__chart__line" style={industryBarStyles}>
                        <span className="br-app-bar__chart__label">{industryScore}% {globalText.barChartIndustryPercentageLabel}</span>
                    </div>
                </div>
            </div>
            <div className="br-app-bar br-app-bar__user">
                <span className="br-app-bar__label">{globalText.barChartBusinessLabel}</span>
                <div className="br-app-bar__chart">
                    <div className={`br-app-bar__chart__line ${barProgressClass}`} style={userBarStyles}>
                    <span className="br-app-bar__chart__label">{userScoreResult}% {globalText.barChartBusinessPercentageLabel}</span>
                    <span className="sr-only">
                    {barProgressSRlabel}
                    </span>
                    </div>
                </div>
            </div>
            
        </div>
    )


};
